/**
 * @generated SignedSource<<4eac88e5e70f96477c7aee951520bdd7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LifetimeReferralsStats_referralsRef$data = {
  readonly lifetime: {
    readonly earnings: {
      readonly currency: string;
      readonly subUnitAmount: number;
    } | null;
    readonly successes: number;
  };
  readonly " $fragmentType": "LifetimeReferralsStats_referralsRef";
};
export type LifetimeReferralsStats_referralsRef$key = {
  readonly " $data"?: LifetimeReferralsStats_referralsRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"LifetimeReferralsStats_referralsRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LifetimeReferralsStats_referralsRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReferralsStats",
      "kind": "LinkedField",
      "name": "lifetime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "successes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CurrencyAmount",
          "kind": "LinkedField",
          "name": "earnings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subUnitAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ReferralHistory",
  "abstractKey": null
};

(node as any).hash = "77a9dddb869d65a597d48f56d1053a7d";

export default node;
